<template>
  <div class="page-container">
    <div class="page-title">
      {{ $t('menu.fx_transactions') }}
    </div>
    <component :is="activeName" />
  </div>
</template>

<script>
import { pageForeignExchange } from '@/api/settlement/settlement'
export default {
  name: 'Data_Payout',
  data(){
    return {
      activeName: '',
    }
  },
  components: {
    FXTransDetails: () => import('./components/FXTransDetails.vue'),
    FXNoTransDetails: () => import('./components/FXNoTransDetails.vue'),

  },
  created(){
    this.getInfo()
  },
  methods:{
    getInfo(params = {}) {
      pageForeignExchange(params).then(res => {
        const { show_foreign_exchange_menu } = res.data || {}
        this.activeName = show_foreign_exchange_menu ? 'FXTransDetails' : 'FXNoTransDetails'
      })
    },
  }

}
</script>

<style scoped>
.page-container{
  margin: 40px 57px 50px 32px;
}
.page-container .page-title {
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
</style>
